export default __webpack_public_path__ + "static/media/oscer-pres-elbow-pain.7aa85338.svg";